import React from 'react'
import axios from 'axios';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Label } from 'reactstrap';
import { Form, Col, fieldset } from 'react-bootstrap';
import { getSessionName, getSessionID, getCompanyID, getToken } from '../../../../Utils/Common';

class AddHoliday extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      modal: false,
      name: '',
      team :'' ,
      country: '',
      company:[],
      holiday_type:[],
      holiday_day:[],
      holiday_site:[],
  };

    this.toggle = this.toggle.bind(this);
	this.handleChangeName = this.handleChangeName.bind(this);
    this.handleChangeTeam = this.handleChangeTeam.bind(this);
    this.handleChangeGender = this.handleChangeGender.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  handleChangeName(event) {
    this.setState({name: event.target.value});
  }
  handleChangeTeam(event) {
    this.setState({team: event.target.value});
  }
  handleChangeGender(event) {
    this.setState({gender: event.target.value});
  }

  handleSubmit(event) {
    event.preventDefault();
  }

  componentDidMount () {
    let self = this;

    const session_Name = getSessionName();
    if (!session_Name) {
      return;
    }
  
    const session_ID = getSessionID();
    if (!session_ID) {
      return;
    }
  
    const company_id = getCompanyID();
    if (!company_id) {
      return;
    }

    const login_token = getToken();
    if (!login_token) {
      return;
    }
    
    var postData = {
      'company_id': company_id
    };

    var company_id_login = {
      'company_id': company_id
    }

    let axiosConfig = {
      headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': login_token,
          'Authentication': session_Name+"="+session_ID,
      }
    };

    axios.post('http://payroll.nikkolim.com/get_form/holiday_definitions/holiday_form', postData, axiosConfig)
    .then((response) => {
         self.setState({ company_id: company_id_login});
         self.setState({ company: response.data.field_holiday_company});
         self.setState({ holiday_type: response.data.field_holiday_type});
         self.setState({ holiday_day: response.data.field_holiday_day});
         self.setState({ holiday_site: response.data.field_holiday_site});
         
         
        //console.log(JSON.stringify(response.data));
    })
    .catch((err) => {
      console.log("AXIOS ERROR: ", err);
    })
  }

  searchSubmit = e => {
    const { value } = e.target;
  };

  render() {

        const { 
          company,
          company_id,
          holiday_type,
          holiday_day,
          holiday_site,
        } = this.state;

    return (

        <div>
        <Button size="sm" color="primary" onClick={this.toggle} className="btn btn-primary" >Create Holiday</Button>
        <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
       isOpen={this.state.modal}>
        <form onSubmit={this.handleSubmit}>
          <ModalHeader>Add Holiday</ModalHeader>
          <ModalBody>
          <Form>
          <fieldset name="primaryInfo">
            {/* <Label for="employee_information">Personal Information</Label> */}
              <Form.Row>
                  <Col md='7'>
                      <Label>Label</Label>
                      <Form.Control required type="text" />
                  </Col>
                  <Col>
                      <Label>Type</Label>
                      <Form.Control defaultValue='-' as="select" onChange={this.searchSubmit}>
                          <option value='-'>-</option>
                        {holiday_type.map(ht => (
                          <option value={ht.id} key={ht.id}>
                            {ht.name}
                          </option>
                          ))}
                      </Form.Control>
                  </Col>
                  <Col>
                      <Label>Day</Label>
                      <Form.Control defaultValue='-' as="select" onChange={this.searchSubmit}>
                          <option value='-'>-</option>
                        {holiday_day.map(hd => (
                          <option value={hd.id} key={hd.id}>
                            {hd.name}
                          </option>
                          ))}
                      </Form.Control>
                  </Col>
              </Form.Row>
              <Form.Row>
                  <Col>
                      <Label>Date</Label>
                      <Form.Control required type="date" />
                  </Col>
                  <Col>
                      <Label>Date Before</Label>
                      <Form.Control required type="date" />
                  </Col>
                  <Col>
                      <Label>Company</Label>
                      <Form.Control disabled defaultValue={company_id} as="select" onChange={this.searchSubmit}>
                        {company.map(company => (
                          <option value={company.id} key={company.id}>
                            {company.name}
                          </option>
                          ))}
                      </Form.Control>
                  </Col>
              </Form.Row>
              <Form.Row>
                  <Col md='4'>
                      <Label>Site</Label>
                      <Form.Control multiple as="select" onChange={this.searchSubmit}>
                        {holiday_site.map(hs => (
                          <option value={hs.id} key={hs.id}>
                            {hs.name}
                          </option>
                          ))}
                      </Form.Control>
                  </Col>
                  <Col md="2">
                      <Label>Active</Label>
                      <Form.Check 
                        type="switch"
                        id="switch-holiday-active"
                        label=""
                      />
                  </Col>
              </Form.Row>

              <Form.Row>
                  <Col>
                      <Label>Description</Label>
                      <Form.Control as='textarea' />
                  </Col>
              </Form.Row>
            </fieldset>
            </Form>
          </ModalBody>
          <ModalFooter>
		  	<Button className= "btn btn-secondary" onClick={this.toggle}>Cancel</Button>
              <Button className= "btn btn-secondary" onClick={this.toggle}>Save</Button>
            {/* <input type="submit" value="Logout" color="primary" className="btn btn-primary" /> */}
          </ModalFooter>
          </form>
        </Modal>
        </div>
      
    );
  }
}

export default AddHoliday;